import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bounce, toast } from "react-toastify";

const data = [
  { id: 1, title: "سُبْحَانَ اللَّهِ", count: 33 },
  { id: 2, title: "ٱلْحَمْدُ لِلَّهِ", count: 33 },
  { id: 3, title: "اللَّهُ أَكْبَر", count: 33 },
  {
    id: 3,
    title:
      "لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَىْءٍ قَدِيرٌ",
    count: 0,
  },
];
function AfterPrayer() {
  const [counter, setCounter] = useState(0);
  const [positionEnd, setPositionEnd] = useState(1);
  const [positionStart, setPositionStart] = useState(0);

  const navigator = useNavigate();
  useEffect(() => {
    if (positionStart === data.length) {
      toast.success("فتح الله عليك لا تنسي الصلاة القادمة", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      return navigator("/");
    }
  });
  return (
    <div className={`flex flex-col gap-5 justify-center relative z-20`}>
      {data.slice(positionStart, positionEnd).map(({ id, title, count }) => (
        <div key={`${id}---${Math.random()}`}>
          <div
            className={`col-md-4 col-lg-8 px-2 w-3/4 mt-[10vh] mx-auto text-center py-2 rounded-[16px] bg-[#ffffff82]`}
          >
            {title}
          </div>
          <div className={`flex flex-col mt-[10vh]`}>
            <span className="px-3 py-2 mx-auto text-center bg-[#ffffff82] rounded-t-[16px]">
              {counter}/{count}
            </span>
            <button
              onClick={() => {
                if (count - 1 > counter) {
                  return setCounter(counter + 1);
                }
                setCounter(0);
                setPositionStart(positionStart + 1);
                return setPositionEnd(positionEnd + 1);
              }}
              className={`p-3 mx-auto text-center bg-[#ffffff82] rounded-[16px]`}
            >
              انقر هنا
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default AfterPrayer;
